(function (root, factory) {
  const search = factory();
  if (typeof module === 'object' && module.exports) module.exports = search;
  else root.apexDesignSearch = search;
})(typeof window === 'undefined' ? globalThis : window, function () {
  'use strict';

  const groups = [
    ['cat', ['cat', 'cats', 'kitty', 'kitties', 'kitten', 'kittens']],
    ['dog', ['dog', 'dogs', 'puppy', 'puppies', 'canine', 'canines'], ['hound', 'hounds', 'bulldog', 'bulldogs', 'mastiff', 'mastiffs']],
    ['bulldog', ['bulldog', 'bulldogs']],
    ['mastiff', ['mastiff', 'mastiffs']],
    ['wolf', ['wolf', 'wolves']],
    ['tiger', ['tiger', 'tigers']],
    ['lion', ['lion', 'lions']],
    ['bear', ['bear', 'bears', 'teddy', 'teddies']],
    ['fox', ['fox', 'foxes']],
    ['rabbit', ['rabbit', 'rabbits', 'bunny', 'bunnies']],
    ['owl', ['owl', 'owls']],
    ['eagle', ['eagle', 'eagles']],
    ['raven', ['raven', 'ravens']],
    ['crow', ['crow', 'crows']],
    ['bat', ['bat', 'bats']],
    ['snake', ['snake', 'snakes', 'serpent', 'serpents']],
    ['fish', ['fish', 'fishes'], ['koi', 'shark', 'sharks']],
    ['koi', ['koi']],
    ['shark', ['shark', 'sharks']],
    ['ram', ['ram', 'rams']],
    ['goat', ['goat', 'goats']],
    ['bull', ['bull', 'bulls']],
    ['crab', ['crab', 'crabs']],
    ['scorpion', ['scorpion', 'scorpions']],
    ['pig', ['pig', 'pigs', 'piglet', 'piglets']],
    ['raccoon', ['raccoon', 'raccoons']],
    ['skunk', ['skunk', 'skunks']],
    ['donkey', ['donkey', 'donkeys']],
    ['lamb', ['lamb', 'lambs']],
    ['skull', ['skull', 'skulls']],
    ['skeleton', ['skeleton', 'skeletons']],
    ['dragon', ['dragon', 'dragons']],
    ['reaper', ['reaper', 'reapers', 'grim reaper']],
    ['witch', ['witch', 'witches']],
    ['vampire', ['vampire', 'vampires']],
    ['ghost', ['ghost', 'ghosts']],
    ['demon', ['demon', 'demons', 'devil', 'devils', 'imp', 'imps']],
    ['pumpkin', ['pumpkin', 'pumpkins', 'jack-o-lantern', 'jack-o-lanterns']],
    ['guitar', ['guitar', 'guitars', 'guitarist', 'guitarists']],
    ['flower', ['flower', 'flowers', 'floral'], ['rose', 'roses', 'hibiscus', 'orchid', 'orchids']],
    ['rose', ['rose', 'roses']],
    ['halloween', ['halloween']],
    ['gothic', ['gothic', 'goth']],
    ['kawaii', ['kawaii']],
    ['anime', ['anime']],
    ['manga', ['manga']],
    ['zodiac', ['zodiac', 'astrology', 'horoscope', 'horoscopes']],
    ['aries', ['aries']],
    ['taurus', ['taurus']],
    ['gemini', ['gemini']],
    ['cancer', ['cancer']],
    ['leo', ['leo']],
    ['virgo', ['virgo']],
    ['libra', ['libra']],
    ['scorpio', ['scorpio']],
    ['sagittarius', ['sagittarius']],
    ['capricorn', ['capricorn']],
    ['aquarius', ['aquarius']],
    ['pisces', ['pisces']]
  ];

  const normalize = value => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const aliases = new Map(groups.flatMap(([key, words]) => words.map(word => [normalize(word), key])));
  const queryPattern = /^\(tag:[a-z0-9-]+(?: OR tag:[a-z0-9-]+)*\)(?: AND \(tag:[a-z0-9-]+(?: OR tag:[a-z0-9-]+)*\))*$/;

  function queryForKeys(keys) {
    return [...new Set(keys)].map(key => {
      const [, words, extra = []] = groups.find(([item]) => item === key);
      const terms = [...new Set([key, ...words, ...extra].filter(word => /^[a-z0-9-]+$/.test(word)))];
      return '(' + terms.map(word => `tag:${word}`).join(' OR ') + ')';
    }).join(' AND ');
  }

  function queryForTerm(value) {
    const term = String(value || '').trim();
    if (/^tag:"apex-search:[a-z0-9-]+"(?: AND tag:"apex-search:[a-z0-9-]+")*(?: AND tag:"Apex Primary")?$/.test(term)) {
      const keys = [...term.matchAll(/tag:"apex-search:([a-z0-9-]+)"/g)].map(match => match[1]);
      return keys.every(key => groups.some(([item]) => item === key)) ? queryForKeys(keys) : term;
    }
    if (/^tag:apxsearch[a-z0-9-]+(?: AND tag:apxsearch[a-z0-9-]+)*$/.test(term)) {
      const keys = [...term.matchAll(/tag:apxsearch([a-z0-9-]+)/g)].map(match => match[1]);
      return keys.every(key => groups.some(([item]) => item === key)) ? queryForKeys(keys) : term;
    }
    const normalized = normalize(term);
    const key = aliases.get(normalized);
    const keys = key ? [key] : normalized.split(' ').map(word => aliases.get(word));
    if (!keys.length || keys.some(item => !item)) return term;
    return queryForKeys(keys);
  }

  function displayTerm(value) {
    const term = String(value || '').trim();
    if (!queryPattern.test(term)) return term;
    const keys = [...term.matchAll(/\(tag:([a-z0-9-]+)/g)].map(match => match[1]);
    return keys.every(key => groups.some(([item]) => item === key)) ? keys.join(' ').replaceAll('-', ' ') : term;
  }

  function tagsForProduct(product) {
    const tags = (product.tags || [])
      .filter(tag => !/^apex[- ]|^artistic apex$/i.test(tag) && !String(tag).includes('|'))
      .map(normalize)
      .filter(Boolean);
    return groups
      .filter(([, words, extra = []]) => [...words, ...extra].some(word => tags.some(tag => ` ${tag} `.includes(` ${normalize(word)} `))))
      .map(([key]) => key);
  }

  if (typeof document !== 'undefined') {
    for (const form of document.querySelectorAll('form[data-design-search]')) {
      form.addEventListener('submit', event => {
        const input = form.querySelector('input[name="q"]');
        if (!input) return;
        const query = queryForTerm(input.value);
        if (query === input.value.trim()) return;
        event.preventDefault();
        const url = new URL(form.action, window.location.href);
        url.search = new URLSearchParams(new FormData(form)).toString();
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'product');
        url.searchParams.delete('page');
        window.location.assign(url.href);
      });
    }

    const searchInput = document.querySelector('#SearchPageInput');
    if (searchInput) {
      const url = new URL(window.location.href);
      const term = url.searchParams.get('q') || '';
      const query = queryForTerm(term);
      if (term && query !== term) {
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'product');
        url.searchParams.delete('page');
        window.location.replace(url.href);
      }
    }
  }

  return { groups, queryForTerm, displayTerm, tagsForProduct };
});
